
export default {
  name: 'Profile',

  middleware: [
    'auth',
    ({ route, redirect }) => {
      // redirect to account subpage if route is an exact match
      if (route.matched.length === 1) {
        redirect('/profile/account')
      }
    },
  ],

  data() {
    return {
      navigationLinks: [
        { titleKey: 'my-account', to: '/profile/account', groups: [] },
        { titleKey: 'personal-data', to: '/profile/details', groups: [] },
        { titleKey: 'my-orders', to: '/profile/orders', groups: [] },
        {
          titleKey: 'my-elearn-products',
          to: '/profile/e-learning',
          groups: [],
        },
        { titleKey: 'my-coupons', to: '/profile/coupons', groups: [] },
        { titleKey: 'my-pdfs', to: '/profile/pdfs', groups: [] },
        {
          titleKey: 'my-shopping-lists',
          to: '/profile/shopping-list',
          groups: [],
        },
        { titleKey: 'my-newsletter', to: '/profile/newsletter', groups: [] },
        { titleKey: 'partner', to: '/profile/partner', groups: ['partner'] },
        {
          titleKey: 'logout',
          callback: this.logout,
          groups: [],
        },
      ],
    }
  },

  head() {
    return {
      title: this.$t('my-account'),
    }
  },

  methods: {
    async logout() {
      await this.$store.dispatch('user/logout')
    },
  },
}
